import React from 'react'
import { LoadingLogo } from '@labrav/react-components'

export const LoadingAuthPage: React.FC = () => {
  return (
    <div
      data-testid="loading-auth-page"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <LoadingLogo style={{ height: 'auto' }} />
    </div>
  )
}
